module.exports = [
  {
    key: 'UPPER_CLOTHES',
    label: {
      en: 'Upper Clothes',
      es: 'Needs Translation'
    },
  },
  {
    key: 'LOWER_CLOTHES',
    label: {
      en: 'Lower Clothes',
      es: 'Needs Translation'
    },
  },
  {
    key: 'UPPER_UNDERWEAR',
    label: {
      en: 'Upper Underwear',
      es: 'Needs Translation'
    },
  },
  {
    key: 'LOWER_UNDERWEAR',
    label: {
      en: 'Lower Underwear',
      es: 'Needs Translation'
    },
  },
  {
    key: 'HEAD_CLOTHES',
    label: {
      en: 'Headwear',
      es: 'Needs Translation'
    },
    outfitRestrictions: [
      'POLICE_OUTFIT_1',
      'OUTFIT_ISLAMIC_1',
      'OUTFIT_1_x_ISLAMIC',
      'OUTFIT_2_x_ISLAMIC',
      'OUTFIT_3_x_ISLAMIC',
      'OUTFIT_4_x_ISLAMIC'
    ],
  },
];

